import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.infra.project.host');
import { OnInit, OnDestroy, Input, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-infra-project-host',
template: templateSource || '',
    styles: [``],
})
export class PortalInfraProjectHostComponent implements OnInit, OnDestroy {
    @Input() id: any;
    @Input() role: any;
    @Input() data: any = {};
    @Input() hosts: any = [];
    @Input() refresh: any;

    public deleteString: any = false;
    public zones: any = [];

    // Searchable Root DNS dropdown
    public zoneSearch: string = '';
    public showZoneDropdown: boolean = false;
    public filteredZones: string[] = [];
    public zoneHighlightIndex: number = -1;

    // Document click handler
    private _docClickBound: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private eRef: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        this._docClickBound = this._onDocumentClick.bind(this);
        document.addEventListener('click', this._docClickBound);
        await this.load();
    }

    public ngOnDestroy() {
        if (this._docClickBound) {
            document.removeEventListener('click', this._docClickBound);
        }
    }

    private _onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        if (this.showZoneDropdown) {
            const zoneContainer = this.eRef.nativeElement.querySelector('.zone-dropdown-container');
            if (zoneContainer && !zoneContainer.contains(target)) {
                this.showZoneDropdown = false;
                this.zoneHighlightIndex = -1;
                this.service.render();
            }
        }
    }

    public async load() {
        const { code, data } = await wiz.call("zone", { id: this.data.id });
        this.zones = data;
        await this.service.render();
    }

    public newdns: any = { name: "", basehost: "" };

    // Zone search/dropdown methods
    public onZoneInput() {
        const input = (this.newdns.basehost || '').toLowerCase();
        if (input.length === 0) {
            this.filteredZones = this.zones;
        } else {
            this.filteredZones = this.zones.filter((z: string) => z.toLowerCase().includes(input));
        }
        this.zoneHighlightIndex = -1;
        this.showZoneDropdown = this.filteredZones.length > 0;
        this.service.render();
    }

    public onZoneFocus() {
        this.onZoneInput();
    }

    public onZoneBlur() {
        // Keep as fallback, but document click handler is primary
    }

    public onZoneKeydown(event: KeyboardEvent) {
        if (!this.showZoneDropdown || this.filteredZones.length === 0) return;

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.zoneHighlightIndex = (this.zoneHighlightIndex + 1) % this.filteredZones.length;
            this.scrollToHighlightedZone();
            this.service.render();
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.zoneHighlightIndex = this.zoneHighlightIndex <= 0
                ? this.filteredZones.length - 1
                : this.zoneHighlightIndex - 1;
            this.scrollToHighlightedZone();
            this.service.render();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            if (this.zoneHighlightIndex >= 0 && this.zoneHighlightIndex < this.filteredZones.length) {
                this.selectZone(this.filteredZones[this.zoneHighlightIndex]);
            }
        } else if (event.key === 'Escape') {
            this.showZoneDropdown = false;
            this.zoneHighlightIndex = -1;
            this.service.render();
        }
    }

    private scrollToHighlightedZone() {
        setTimeout(() => {
            const el = document.querySelector('.zone-dropdown-item.highlighted');
            if (el) el.scrollIntoView({ block: 'nearest' });
        });
    }

    public selectZone(zone: string) {
        this.newdns.basehost = zone;
        this.showZoneDropdown = false;
        this.zoneHighlightIndex = -1;
        this.service.render();
    }

    public hostName(item: any): string {
        if (!item) return '';
        if (item.host) return item.host;
        const name = (item.name || '').trim();
        const basehost = (item.basehost || '').trim();
        return name ? `${name}.${basehost}` : basehost;
    }

    public async addDNS() {
        this.newdns.id = this.data.id;
        const { code, data } = await wiz.call("add_dns", this.newdns);
        if (code == 200) {
            await this.refresh();
            this.newdns = { name: "", basehost: "" };
        } else {
            await this.service.modal.error(data);
        }
        await this.service.render();
    }

    public async deleteDNS(item: any) {
        if (!await this.service.modal.error(`Are you sure delete '${this.hostName(item)}'?`, `Cancel`, `Delete`)) return;
        item.id = this.data.id;
        const { code, data } = await wiz.call("delete_dns", item);
        if (code == 200) {
            await this.refresh();
        } else {
            await this.service.modal.error(data);
        }
        await this.service.render();
    }
}

export default PortalInfraProjectHostComponent;